import { Column } from '@/styles/common';
import React, { useEffect, useState } from 'react';

interface StringFieldProps extends INonNullableField<string> {}

const StringField: React.FC<StringFieldProps> = ({
	value,
	disabled,
	fieldClassName,
	label,
	setValue,
	variant,
	...props
}) => {
	const [state, setState] = useState(value || '');

	useEffect(() => {
		setState(value || '');
	}, [value]);

	const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			(e.target as any).blur();
		}
	};

	const onBlur = () => {
		if (setValue && state !== (value || '')) {
			setValue(state);
		}
	};

	const _disabled = disabled || !setValue;

	return (
		<Column>
			{label && <label>{label}</label>}
			<input
				{...props}
				value={state}
				onChange={(e) => {
					setState(e.target.value);
				}}
				disabled={_disabled}
				onBlur={onBlur}
				onKeyDown={onKeyDown}
			/>
		</Column>
	);
};

export default StringField;
